// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1U3HA","location":"Header_location__3UUb9"};